import { PETS_APIS } from "@/api_framework/api_config";
import { ICustomerPetUpdationBody, ICustomerPetUpdationResponse } from "@/api_framework/api_modals/Pets";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
// returns new created userId
export const useCustomerPetUpdationAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [newPetId, setNewPetId] = useState<string | null>("");
  const execute = useCallback(
    async (formData: ICustomerPetUpdationBody, userId: string, petId: string): Promise<string | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response: string = await axios
          .put(`${PETS_APIS?.UPDATE_PET?.baseURL}${userId}/${petId}/`, formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<ICustomerPetUpdationResponse>) => {
            if (res.data.status === true) {
              toastNotification(`${formData.pet_name} pet updated successfully.`);
              setNewPetId(res.data?.data?.pet_id);
              dispatch(
                setLoading({
                  key: "isCustomerPetUpdationInProgress",
                  status: false,
                }),
              );
              return res.data.data.pet_id;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config?.["curlCommand"]);
            return null;
          });
        return response;
      } catch (e: any) {
        captureError(e);

        return null;
      }
      return null;
    },
    [],
  );
  return { newPetId, execute };
};
